import { buildGuestSettingsUrl, buildSettingsUrl } from '../app/navigationState';
import { resolvePasswordPolicy } from './passwordPoliciesApi';
import { isPassphraseExpired, type PasswordPolicyTarget } from './passwordPolicy';

const FORCE_CHANGE_KEY = 'shareweb:forcePassphraseChange';

export function setForcePassphraseChange(required: boolean): void {
  if (required) {
    sessionStorage.setItem(FORCE_CHANGE_KEY, '1');
  } else {
    sessionStorage.removeItem(FORCE_CHANGE_KEY);
  }
}

export function isForcePassphraseChangeRequired(): boolean {
  return sessionStorage.getItem(FORCE_CHANGE_KEY) === '1';
}

export async function enforcePassphraseMaxAge(input: {
  passphraseSetAt: string | null | undefined;
  target: PasswordPolicyTarget;
  guest?: boolean;
}): Promise<boolean> {
  const policy = await resolvePasswordPolicy(input.target);
  const expired = isPassphraseExpired(input.passphraseSetAt, policy.maxAgeDays);
  setForcePassphraseChange(expired);
  if (!expired) {
    return false;
  }

  const url = input.guest
    ? buildGuestSettingsUrl('passphrase')
    : buildSettingsUrl('passphrase');
  if (window.location.pathname !== url) {
    history.pushState({}, '', url);
    window.dispatchEvent(new PopStateEvent('popstate'));
  }
  return true;
}
